import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
import { useTranslation } from '../lib/i18n';
export function AboutCaro() {
  const {
    t
  } = useTranslation();
  const images = ['https://cdn.rawproductionsgmbh.de/caro/highlights/highlights-1.jpg', 'https://cdn.rawproductionsgmbh.de/caro/highlights/highlights-2.jpg', 'https://cdn.rawproductionsgmbh.de/caro/highlights/highlights-3.jpg', 'https://cdn.rawproductionsgmbh.de/caro/highlights/highlights-4.jpg', 'https://cdn.rawproductionsgmbh.de/caro/highlights/highlights-5.jpg', 'https://cdn.rawproductionsgmbh.de/caro/highlights/highlights-6.jpg', 'https://cdn.rawproductionsgmbh.de/caro/highlights/highlights-7.jpg', 'https://cdn.rawproductionsgmbh.de/caro/highlights/highlights-9.jpg'];
  const blocks = t.about.blocks.map((block, index) => ({
    ...block,
    image: images[index],
    alt: `Caro Loesel - ${block.heading}`,
    reverse: index % 2 !== 0,
    link: index === 3 ? {
      url: 'https://www.model-kartei.de/sedcards/model/674011/caro-loesel/',
      label: block.link
    } : undefined
  }));
  return <section className="py-20 px-4 md:px-8 max-w-5xl mx-auto" data-id="element-9">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="text-center mb-16 md:mb-24" data-id="element-10">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-[#1A1A1A] mb-4" data-id="element-11">
          {t.about.title}
        </h2>
        <div className="w-16 h-1 bg-hotpink mx-auto rounded-full" data-id="element-12" />
      </motion.div>

      <div className="space-y-20 md:space-y-32" data-id="element-13">
        {blocks.map((block, index) => <div key={index} className={`grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center`} data-id="element-14">
            {/* Image Column */}
            <motion.div initial={{
          clipPath: 'inset(10% 10% 10% 10%)'
        }} whileInView={{
          clipPath: 'inset(0% 0% 0% 0%)'
        }} viewport={{
          once: true,
          margin: '-10%'
        }} transition={{
          duration: 1.2,
          ease: [0.22, 1, 0.36, 1]
        }} className={`relative group ${block.reverse ? 'md:order-last' : 'md:order-first'} order-first`} data-id="element-15">
              <div className="relative rounded-xl overflow-hidden aspect-[4/5] border border-[#1A1A1A]/5 transition-all duration-500 group-hover:border-hotpink/50 group-hover:shadow-xl group-hover:shadow-hotpink/10" data-id="element-16">
                <img src={block.image} alt={block.alt} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-17" />
              </div>
            </motion.div>

            {/* Text Column */}
            <motion.div initial={{
          opacity: 0,
          x: block.reverse ? 30 : -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className={`${block.reverse ? 'md:order-first' : 'md:order-last'} order-last text-left pl-6 border-l-4 border-hotpink`} data-id="element-18">
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-[#1A1A1A] mb-4" data-id="element-19">
                {block.heading}
              </h3>
              <p className="text-text-secondary text-base md:text-lg leading-relaxed font-light font-sans mb-6" data-id="element-20">
                {block.text}
              </p>

              {block.link && <a href={block.link.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-hotpink font-semibold hover:text-hotpink/80 transition-colors group" data-id="element-21">
                  {block.link.label}
                  <ExternalLink className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-22" />
                </a>}
            </motion.div>
          </div>)}
      </div>
    </section>;
}